<script>
import { ref, reactive, computed, onMounted } from 'vue'
import { useForm } from 'vee-validate';
import * as yup from 'yup';
import LandingOffer from './LandingOffer'
import LandingInfo from './LandingInfo'
import LandingCard from './LandingCard'
import LandingFooter from './LandingFooter.vue'
import InputText from './InputText.vue'
import InputSelect from './InputSelect.vue'
import Recaptcha from '../../common/components/Recaptcha.vue'

export default {
  name: 'PageLandingFioulProfessionnel',
  components: {
    LandingOffer,
    LandingInfo,
    LandingCard,
    LandingFooter,
    InputText,
    InputSelect,
    Recaptcha,
  },
  props: {
    optin: {
      type: String,
      default: '',
    },
    hasmezzo: {
      type: String,
      default: '0',
    },
  },
  setup(props) {
    const recaptcha = ref(null)
    const selects = reactive({
      types: [
        'Industrie',
        'Immobilier',
        'Collectivités locales',
        'Agriculture',
        'Copropriété',
        'Hôtel / Restaurant',
        'Commerce',
        'Garage',
        'TPE/PME',
        'EHPAD',
        'Autre secteur',
      ],
    })

    const cards = reactive([
      {
        title: 'Votre chaudière gaz très haute performance accessible avec une offre de financement à taux gratuit',
        text: 'Le gaz émet moins de CO2 que le fioul.',
        img: 'chaudiere_draw',
      },
      {
        title: '0€ à l’installation de la citerne',
        sup: '(*)',
        text: 'Vous ne payez rien quand vous vous équipez d’une citerne Antargaz.',
        img: 'tool',
      },
      {
        title: 'Des modes de paiement adaptés à vos besoins',
        sup: '(*)',
        text: 'Vous avez accès à différentes options qui répondent pleinement aux spécificités de votre activité.',
        img: 'calendar',
      },
      {
        title: "Un service prix du gaz garanti jusqu'à 2 ans",
        sup: '(*)',
        text: 'Cette tarification vous garantit une maîtrise de votre budget énergétique.',
        img: 'lock',
      },
      {
        title: 'Un contrat à la durée de votre choix',
        sup: '(*)',
        text: 'Vous êtes libre de déterminer la durée du contrat de gaz.',
        img: 'docs',
      },
      {
        title: 'Retrait ou inertage de la cuve fioul',
        text: 'Un accompagnement pourra être apporté pour gérer le retrait ou l’inertage de votre cuve fioul.',
        img: 'removal_fioul',
      },
    ])

    const isPosted = ref(false)
    const captchaError = ref(false)
    const formEl = ref(null)

    const form = reactive({
      type: '',
      company_name: '',
      lastname: '',
      firstname: '',
      zipcode: '',
      phone: '',
      email: '',
      acceptance: '',
      captcha: '',
      mention: '',
      specify_your_request: '',
      mezzo: props.hasmezzo,
    })

    const { values, errors, defineField, validate } = useForm({
          validationSchema: yup.object({
            lastname: yup.string().required('Le nom est requis'),
            firstname: yup.string().required('Le prénom est requis'),
            type: yup.string().required('Le type est requis'),
            zipcode: yup.number().required('Le code postal est requis'),
            companyname: yup.string().required('Le nom de la companie est requis'),
            email: yup.string().email('L\'email est invalide').required('L\'email est requis'),
              }),
            phone: yup
              .string()
              .matches(/^(0|\+33)[0-9]{9}$/, 'Le numéro de téléphone est invalide'),
        });

    const [type, typenameAttrs] = defineField('type', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [companyname, companynameAttrs] = defineField('companyname', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [lastname, lastnameAttrs] = defineField('lastname', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [firstname, firstnameAttrs] = defineField('firstname', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [email, emailAttrs] = defineField('email', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [phone, phoneAttrs] = defineField('phone', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });

    const [zipcode, zipcodeAttrs] = defineField('zipcode', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const showForm = computed(() => !isPosted.value)
    const showConfirmation = computed(() => isPosted.value)

    const updateDatalayer = (formData) => {
      formData.form_name = formData.form_name
        .trim()
        .replace(/["+?!\n#_', ]/g, ' ')
        .replace(/\s+/g, ' ')
        .replace(/ /g, '_')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')

      formData.form_category = form.type
        .trim()
        .replace(/[#_',\/]/g, '_')
        .replace(/["+?! ]/g, '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')

      window.dataLayer.push(formData)
    }

    const scrollToForm = () => {
      document.getElementById('form').scrollIntoView()
    }

    const onCaptchaExpired = () => {
      recaptcha.value.reset()
      captchaError.value = true
    }

    const onCaptchaVerified = (token) => {
      recaptcha.value.reset()
      form.captcha = token
      submitForm()
    }

    const checkRecaptcha = () => {
      captchaError.value = false
      recaptcha.value.execute()
    }

    const submitForm = () => {
      if (form.captcha.length > 0) {
        sendForm()
      }
    }

    const sendForm = () => {

      form.lastname = lastname
      form.firstname = firstname
      form.type = type
      form.phone = phone
      form.email = email
      form.company_name = companyname
      form.zipcode = zipcode

      const formData = {
        event: 'form_confirmation',
        form_type: 'Landing_Fioul_professionnel',
        form_name: document.querySelector('h1.title.title--1')?.textContent || '',
        form_category: form.type,
      }

      Object.entries(form).forEach(([key, value]) => {
        let input = formEl.value?.querySelector(`[name='${key.toLowerCase()}']`)

        if (input) {
          switch (key) {
            case 'mention':
              input.value = value ? props.optin : ''
              break
            case 'acceptance':
              input.value = 'Envoyer mon email'
              break
            default:
              input.value = value
              break
          }
        }
      })

      updateDatalayer(formData)
      formEl.value?.submit()
    }

    onMounted(() => {
      formEl.value = document.querySelector('form')
      isPosted.value = formEl.value?.querySelector('.webform-confirmation') !== null

      window.dataLayer = window.dataLayer || []
      const itemToPush = {}
      const H1 = document.querySelector('h1')

      if (H1) {
        itemToPush['pagename'] = H1.textContent
          .replace(/["+?!]/g, '')
          .replace(/[#_', ]/g, '_')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
      }

      itemToPush['pagetype'] = 'Landing page'
      itemToPush['event'] = 'page_load'

      window.dataLayer.push(itemToPush)
    })

    return {
      selects,
      cards,
      form,
      formEl,
      isPosted,
      captchaError,
      recaptcha,
      showForm,
      showConfirmation,
      updateDatalayer,
      scrollToForm,
      onCaptchaExpired,
      onCaptchaVerified,
      checkRecaptcha,
      submitForm,
      sendForm,
      type,
      firstname,
      lastname,
      companyname,
      email,
      phone,
      errors,
      values,
      zipcode
    }
  },
}
</script>


<style scoped lang="sass">
@import ../../common/styles/settings
@import ../../common/styles/mixins
@import settings
@import typography
@import PageLandingFioulProfessionnel
@import LandingForm
</style>
